'use strict';

module.exports = paragraph;

function paragraph(node) {
  return this.all(node).join('');
}



//////////////////
// WEBPACK FOOTER
// ./~/remark/~/remark-stringify/lib/visitors/paragraph.js
// module id = 454
// module chunks = 35783957827783 251955352258861